import { useEffect, useState } from 'react';
import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { DEFAULT_ADDRESS, useCoverageToolModalProvider } from '../../coverageToolModal.context';
import CoverageToolAuto from './components/coverageToolAuto';

const CoverageToolAutoCard = ({ handleGoNextSlide }: ICommonData) => {
  const [enableNext, setEnableNext] = useState(false);
  const { offerId, setAddress, setIsAddressConfirmed, setIsSuccess, setIsError } =
    useCoverageToolModalProvider();

  const onReset = () => {
    setAddress(DEFAULT_ADDRESS);
  };

  const onSubmit = () => {
    if (handleGoNextSlide) {
      setTimeout(() => {
        setEnableNext(true);
      }, 500);
    }
  };

  useEffect(() => {
    if (enableNext && handleGoNextSlide) {
      handleGoNextSlide();
    }
  }, [enableNext]);

  useEffect(() => {
    onReset();
    setIsAddressConfirmed(false);
    setIsSuccess(false);
    setIsError(false);
  }, []);

  return (
    <CoverageToolAuto
      offerId={offerId}
      onSubmit={onSubmit}
      state={DEFAULT_ADDRESS}
      onReset={onReset}
    />
  );
};

export default CoverageToolAutoCard;
